import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
  return (
    <Container>
      <h2>non è stato possibile trovare la risorsa richiesta</h2>
      <BackToHome to={'/'}>Torna alla home</BackToHome>
    </Container>
  )
}

export default NotFound

//region Style

const Container = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  height: 50%;
  min-height: 400px;
`

const BackToHome = styled(Link)`
  color: var(--primary);
  background: -webkit-linear-gradient(#6353a9, #7c6ab1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font: inherit;
  font-size: 2.5rem;
`
//endregion
